import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SectionPromo.scss'; 

function SectionPromo() {
    const imageRef = useRef(null);
    const [isActive, setIsActive] = useState(false); // Estado para controlar a classe ativado
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Estado para verificar o modo móvel

    const goToOffer = () => {
        const url = 'https://pizzaprime.voceqpad.com.br/store/oferta-imperdivel!';
        window.open(url, '_blank');
    };

    const handleMouseEnter = () => {
        if (!isMobile) {
            setIsActive(true);
        }
    };

    const handleMouseLeave = () => {
        if (!isMobile) {
            setIsActive(false);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5, // 0 = totalmente visível, 1 = totalmente invisível
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                }
            });
        }, options);

        if (imageRef.current) {
            observer.observe(imageRef.current);
        }

        // Cleanup
        return () => {
            if (imageRef.current) {
                observer.unobserve(imageRef.current);
            }
        };
    }, []);

    return (
        <div 
            className='promo-container'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div 
                className={`backEffect ${isActive ? 'ativado' : ''}`} 
            ></div>
            <div className='image-container' ref={imageRef}>
                <img src='img/combo_supremo_pizza_prime.png' alt='Pizza' />
            </div>
            <div className={`promo-details ${isActive ? 'ativado' : ''}`}>
                <div className={`promo-badge ${isActive ? 'ativado' : ''}`}>
                    APROVEITE
                </div>
                <div className={`promo-title ${isActive ? 'ativado' : ''}`}>
                    <h1>Oferta Imperdível</h1>
                </div>
                <div className={`promo-list ${isActive ? 'ativado' : ''}`}>
                    <div className='promo-item'>
                        <div className='promo-item-name'>1 Pizza Grande</div>
                        <div className='promo-item-name'>+ 1 Refri 1,5L</div>
                    </div>
                    <div className='promo-price'>
                        <div className='rs'>R$</div>
                        <div className={`promo-price-whole ${isActive ? 'ativado' : ''}`}>
                          79
                        </div>
                        <div className={`promo-price-decimal ${isActive ? 'ativado' : ''}`}>
                          ,90
                        </div>
                    </div>
                </div>
                <div className={`order-button ${isActive ? 'ativado' : ''}`}>
                    <Link to='' className={`a-button ${isActive ? 'ativado' : ''}`} onClick={goToOffer} >
                      Pedir Agora
                    </Link>
                </div>
            </div>      
        </div>
    );
}

export default SectionPromo;
